import { computed, Ref } from 'vue'

import { useTr } from '@/composables/use-tr'
import { useAppStore } from '@/store/app-store'
import { APIGameType, PlatformType } from '@/types'

export function useGameAvailability(game: Ref<APIGameType | undefined>) {
    const appStore = useAppStore()
    const tr = useTr()

    const availablePlatforms = computed(() =>
        [game.value?.is_desktop && 'desktop', game.value?.is_android && 'android', game.value?.is_ios && 'ios'].filter(
            (p): p is PlatformType => !!p,
        ),
    )

    const isPlatformAvailable = computed(() => availablePlatforms.value.includes(appStore.platform))

    const limitedAvailability = computed(() => {
        if (isPlatformAvailable.value || !game.value) {
            return false
        }

        const translations: Record<PlatformType, string> = {
            desktop: tr('gameContainer.desktop'),
            android: tr('gameContainer.android'),
            ios: tr('gameContainer.ios'),
        }

        const platforms = availablePlatforms.value.map((platform) => translations[platform])

        return platforms.length === 1
            ? tr('gameContainer.limitedAvailability1', {
                  platform: platforms[0] as string,
              })
            : tr('gameContainer.limitedAvailabilityMany', {
                  platforms: platforms.slice(0, -1).join(', '),
                  lastPlatform: platforms.at(-1) as string,
              })
    })

    return {
        isPlatformAvailable,
        limitedAvailability,
    }
}
